import store from '@/state/store';
import { markAsDelivered } from '@/api/events';
import { handleError } from '.';

export default async () => {
  try {
    const list = store.getState().common.newNotifications;
    if (list.length) {
      await markAsDelivered(list.map(({ eventId }) => eventId));
    }
  } catch (error) {
    handleError(error);
  }
};